var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"relative w-full flex justify-center"},[_c(_setup.OzBaseButton,{ref:"buttonRef",class:[
      // Shape
      _setup.isTouch ? 'h-9 w-9' : ['pen', 'highlighter', 'eraser'].includes(_setup.props.iconName) ? 'h-8 w-8' : 'h-6 w-6',
      'rounded-full',
      'p-0',
      'm-0',

      // Color
      {
        'hhover:bg-transparent hactive:bg-transparent hfocus-visible:bg-transparent': _setup.isColorIcon,
      },

      _setup.bgColorClass != null
        ? _setup.bgColorClass
        : {
            'bg-transparent': true,
            'hhover:bg-light-ui-100/20 hactive:bg-light-ui-100/40 ': _vm.colorScheme === 'dark' && !_vm.isSelected,
            'hhover:bg-dark-ui-100/10 hactive:bg-dark-ui-100/20': _vm.colorScheme === 'light' && !_vm.isSelected,
          },

      // Color
      !_vm.isSelected && _vm.colorScheme === 'dark'
        ? ['hfocus-visible:ring-3', 'hfocus-visible:ring-canary-500', 'hfocus-visible:bg-modal-overlay-canary/20']
        : '',
      !_vm.isSelected && _vm.colorScheme === 'light'
        ? ['hfocus-visible:ring-3', 'hfocus-visible:ring-grape-500', 'hfocus-visible:bg-modal-overlay-grape/20']
        : '',
      _vm.isSelected && _vm.colorScheme === 'dark' ? ['hfocus-visible:ring-3', 'hfocus-visible:ring-canary-500'] : '',
      _vm.isSelected && _vm.colorScheme === 'light' ? ['hfocus-visible:ring-3', 'hfocus-visible:ring-grape-500'] : '',

      // Transition
      'transition-all',
      'duration-250',
      'ease-in-out',

      // Children positioning
      'flex',
      'items-center',
      'justify-center',
      'relative',

      // Children styling
      'group',
      'text-body-small',
      'font-semibold',
      _setup.iconColorClass != null
        ? _setup.iconColorClass
        : {
            'text-light-text-200': _vm.colorScheme === 'dark' && !_vm.isSelected,
            'text-dark-text-200': _vm.colorScheme === 'light' && !_vm.isSelected,
            'text-light-text-100': _vm.isSelected && _vm.colorScheme === 'light',
            'text-dark-text-100': _vm.isSelected && _vm.colorScheme === 'dark',
          },
    ],attrs:{"size-preset":undefined,"color-scheme":undefined,"dark-mode":_vm.colorScheme === 'dark',"label":_vm.label},on:{"pointerenter":_setup.onPointerEnter,"focus":_setup.onPointerEnter,"pointerleave":_setup.onPointerLeave,"blur":_setup.onPointerLeave,"pointerup":_setup.onPointerUp,"click":_setup.onPointerDown}},[(!_setup.isSvgIcon)?_c(_setup.OzIcon,{attrs:{"font":_setup.iconFont,"name":_setup.props.iconName,"size":_setup.isTouch ? 24 : 20}}):_c(_setup.WhiteboardSvgIcon,{class:[_setup.iconColorClass, _setup.extraClass],attrs:{"name":_setup.props.iconName,"size":_setup.isTouch && _setup.isColorIcon ? 36 : _setup.isTouch ? 30 : _setup.isColorIcon ? 24 : 15,"color-scheme":_vm.colorScheme,"is-hovered":_setup.isHovered,"is-active":_setup.isActive,"is-selected":_vm.isSelected,"is-opaque-outline-color":(_vm.colorScheme === 'dark' && _setup.iconColor === 'dark-text-100') ||
        (_vm.colorScheme === 'light' && _setup.iconColor === 'light-text-100'),"fill-text-color-class":_setup.props.iconColor && _setup.getTailwindColorClass(_setup.SHAPE_BORDER_TO_FAKE_FILL_COLOR_MAP[_setup.props.iconColor])}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }